import React, { memo } from 'react'
import { BWIcon, BW_COLOR_ACCENT } from 'src/libs/qb-brand-web-components'

import ProviderIcon from '../shared/exchangeProviderCard/ProviderIcon'

const BuyPointsProviderIcon = ({ icon, bgImage }) => {
  return (
    <ProviderIcon
      icon={icon && <BWIcon icon={icon} />}
      color={BW_COLOR_ACCENT}
      src={bgImage}
    />
  )
}

export default memo(BuyPointsProviderIcon)
